export const getWeekOfTheMonth = (date) => {
    const day = date.getDate()
    const weekDay = date.getDay()
    let week = Math.ceil(day / 7)
    
    const ordinal = ['1st', '2nd', '3rd', '4th', '5th']
    const weekDays  = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    
  
    // Check the next day of the week and if it' on the same month, if not, respond with "Last"
    const nextWeekDay = new Date(date.getTime() + (1000 * 60 * 60 * 24 * 7))
    if (nextWeekDay.getMonth() !== date.getMonth()) {
      week = 5
    }
    
    return `${ordinal[week - 1]} ${weekDays[weekDay]}`
  }

  export const getOrdinalSuffix = (dt) => {
    return dt.getDate()+(dt.getDate() % 10 == 1 && dt.getDate() != 11 ? 'st' : (dt.getDate() % 10 == 2 && dt.getDate() != 12 ? 'nd' : (dt.getDate() % 10 == 3 && dt.getDate() != 13 ? 'rd' : 'th'))); 
  }